import React from 'react';
import BrandingFooter from '../common/BrandingFooter';
import MatchWidgetShell from '../common/MatchWidgetShell';
import MatchScoreHero from '../common/MatchScoreHero';
import MatchMetaGrid from '../common/MatchMetaGrid';
import MatchStatsChips from '../common/MatchStatsChips';
import MatchGoalsSection from '../common/MatchGoalsSection';
import { matchStatusConfig } from '../common/matchWidgetUtils';

export default function MatchCard({
  showBranding = false,
  competitionLabel = 'Premier League',
  featuredMatch = { home: 'Arsenal', away: 'Chelsea', score: '2–1', status: 'live' },
}) {
  const match = featuredMatch || {};
  const status = matchStatusConfig(match);
  const events = match.events || match.goals || [];
  const goals = events.filter((e) => e.type === 'goal' || !e.type);
  const isUpcoming = status.key === 'upcoming';

  return (
    <div>
      <MatchWidgetShell showCompetition={false}>
        <MatchScoreHero match={match} />
        <MatchStatsChips match={match} events={events} />
        <MatchMetaGrid match={match} />
        {!isUpcoming && goals.length > 0 && (
          <MatchGoalsSection match={match} goals={goals} title="Match goals" />
        )}
        {isUpcoming && (
          <div className="px-4 pb-5">
            <div
              className="text-center py-4 rounded-xl border text-sm font-semibold"
              style={{ borderColor: 'var(--sw-border)', background: 'var(--sw-card)', color: 'var(--sw-muted)' }}
            >
              Kick-off: {match.kickoff || match.score || 'TBC'}
            </div>
          </div>
        )}
      </MatchWidgetShell>
      {showBranding && <BrandingFooter />}
    </div>
  );
}
